import { boolean, object, string, array, TypeOf } from 'yup'

export const quizFormSchema = object({
  question: string().required('問題文は必須です').default(''),
  correct: string().required('正解は必須です').default(''),
  design: string().ensure().default('ORIGINAL'),
  wrongs: array()
    .test(
      'requied_one',
      '間違いは1つ以上必要です',
      (values) => !!values?.some(Boolean)
    )
    .default(['']),
  imageUrl: string().ensure().default(''),
  answerImageUrl: string().ensure().default(''),
  description: string().ensure().default(''),
  snsShareText: string().ensure().default(''),
  destinationLink: string()
    .url('「遷移先リンク」はURL形式で入力してください。')
    .ensure()
    .default(''),
  destinationLinkText: string().ensure().default(''),
  published: boolean().default(false),
}).defined()

export type QuizFormValues = TypeOf<typeof quizFormSchema>
